import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "../api";
import { Logo } from "../components/Logo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/password-reset/request", { email: email.trim() });
      setSubmitted(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-6 py-12"
      style={{ backgroundColor: "var(--auprea-cream)" }}
    >
      <div className="w-full max-w-md">
        <Link to="/" className="block mb-10 text-center">
          <Logo size={36} />
        </Link>
        <div className="auprea-card">
          {submitted ? (
            <>
              <div
                style={{
                  color: "var(--auprea-gold)",
                  fontSize: 12,
                  letterSpacing: "0.2em",
                  textTransform: "uppercase",
                  fontWeight: 600,
                  marginBottom: 12,
                }}
              >
                — Email envoyé
              </div>
              <h1 style={{ fontSize: 26, marginBottom: 12 }} data-testid="forgot-success-title">
                Vérifiez votre boîte mail
              </h1>
              <p style={{ color: "rgba(35,38,46,0.75)", fontSize: 15, lineHeight: 1.6, marginBottom: 16 }}>
                Si un compte AUPREA est associé à <strong>{email}</strong>, vous recevrez
                dans quelques instants un email contenant un lien sécurisé pour réinitialiser
                votre mot de passe.
              </p>
              <p style={{ color: "rgba(35,38,46,0.6)", fontSize: 13, marginBottom: 24 }}>
                Le lien est valable <strong>1 heure</strong> et ne fonctionne qu'une seule fois.
                Pensez à vérifier le dossier « courriers indésirables ».
              </p>
              <Link
                to="/connexion"
                className="auprea-btn w-full inline-block text-center"
                data-testid="forgot-back-to-login"
              >
                Retour à la connexion
              </Link>
            </>
          ) : (
            <>
              <h1 style={{ fontSize: 28, marginBottom: 6 }}>Mot de passe oublié</h1>
              <p style={{ color: "rgba(35,38,46,0.7)", marginBottom: 28, fontSize: 15 }}>
                Entrez votre email : nous vous enverrons un lien sécurisé
                pour choisir un nouveau mot de passe.
              </p>
              <form onSubmit={submit} className="space-y-5">
                <div>
                  <label className="auprea-label">Email</label>
                  <input
                    type="email"
                    className="auprea-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoFocus
                    data-testid="forgot-email"
                  />
                </div>
                {error && (
                  <div
                    style={{
                      color: "#b53a3a",
                      fontSize: 14,
                      padding: "10px 12px",
                      backgroundColor: "#fcf3f3",
                      border: "1px solid #f0c5c5",
                    }}
                    data-testid="forgot-error"
                  >
                    {error}
                  </div>
                )}
                <button
                  type="submit"
                  className="auprea-btn w-full"
                  disabled={loading}
                  data-testid="forgot-submit"
                >
                  {loading ? "Envoi en cours…" : "Recevoir le lien de réinitialisation"}
                </button>
              </form>
              <div className="mt-6 text-center text-sm" style={{ color: "rgba(35,38,46,0.7)" }}>
                <Link to="/connexion" style={{ color: "var(--auprea-blue)" }}>
                  ← Retour à la connexion
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
